module.exports = __webpack_public_path__ + "static/media/lights@2x.30c33a89.png";